import Authentification from './views/Authentification'
import ResetPassword from './views/ResetPassword'

const route = [
  {
    path: '/login',
    name: 'autentification',
    component: Authentification,
    meta: {
      layout: 'blank'
    }
  },
  {
    path: '/reset-password',
    name: 'resetpassword',
    component: ResetPassword,
    meta: {
      layout: 'blank'
    }
  }
]

export default route